export const environment = {
    production: false,
    APP_URL: 'lamainapp.onpousse.com',
    API_URL: 'https://api-lamainapp.onpousse.com/api',
    ASSETS_PATH: 'https://api-lamainapp.onpousse.com/uploads',
    LOG_LEVEL: 'debug',
    wsUrl: 'wss://api-lamainapp.onpousse.com/ws/notifications',
};
